module.exports = __webpack_public_path__ + "static/promo-mob-7847f55dab0ae26cc2465726d1bb59c6.png";